module.exports = __webpack_public_path__ + "9c9deee6dc3a7d9b423f1b3d1a9e1742.png";